import { Http } from "../Http";
import axios, { AxiosPromise } from "axios";
import { getUserAccessToken } from "../selectors/Accounts";
export class UserService {
	public static userSave(input: any) {
		return input.user.userId >= 0 ?
			Http.axios().put('/api/User/update', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
				.then((res: any) => {
					return res;
				}).catch((e: any) => {
					return e.response;
				})
			:
			Http.axios().post('/api/User/create', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
				.then((res: any) => {
					return res;
				}).catch((e: any) => {
					return e.response;
				});
	}

	public static userGetByFilter(input: any) {
		return Http.axios().post('/api/User/GetByFilter', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static userGetCountByYear(input: any) {
		return Http.axios().get('/api/User/GetUsersCountByYear?year=' + input, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static userRoleGetByFilter() {
		return Http.axios().get('/api/Roles/getall', { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static userGetDetail(id: any, userName: any) {
		return Http.axios().get('/api/User/details/' + id + '?userName=' + userName, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}


	public static userDelete(input: any) {
		return Http.axios().delete('/api/User/delete/' + input, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static userRoleGet(roleCode: any) {
		return Http.axios().get('/api/User/getbyrole/' + roleCode, { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static userGetAddress(input: any) {
		return Http.axios().post('/api/User/getUserAddressByFilter', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static userGetPaymentsByFilter(input: any) {
		return Http.axios().post('/api/User/GetUserPaymentsByFilter', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static userUpdateActiveStatus(userId: any) {
		return Http.axios().delete('/api/User/deactivate/' + userId, { headers: { 'Authorization': getUserAccessToken() } })
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static userSaveCommunity(input: any) {		
		return input.user.userId >= 0 ?
			Http.axios().put('/api/User/updatecommunityuser', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
				.then((res: any) => {
					return res;
				}).catch((e: any) => {
					return e.response;
				})
			:
			Http.axios().post('/api/User/createcommunityuser', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
				.then((res: any) => {
					return res;
				}).catch((e: any) => {
					return e.response;
				})
	}


	public static userSaveAddress(input: any) {
		return Http.axios().post('/api/User/AddUserAddress', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static userRoleSave(input: any) {
		return Http.axios().post('/api/UserRole/addorupdate', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

	public static userAccountUpdate(input: any) {
		return Http.axios().put('/api/User/UpdateAccount', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			}).catch((e: any) => {
				return e.response;
			});
	}
	public static userGetShopifyAddress(input: any) {
		return Http.axios().post('/api/Shop/getcustomeraddresses', JSON.stringify(input), { headers: { 'Authorization': getUserAccessToken() } })
			.then((res: any) => {
				return res;
			})
			.catch((e: { response: any; }) => {
				return e.response;
			}) as AxiosPromise<any>;
	}

}
